import React, { useEffect } from 'react';

import ClosedMenu from './closedMenu/ClosedMenu';
import OpenedMenu from './openedMenu/OpenedMenu';

import useAppState, { OpenStatusEnum } from './useAppState';
import { getRequestLocationKey, getRequestMetadata } from './utils/urlLocationEntityRules';
import { useQuery } from '@tanstack/react-query';
import getData from './utils/api';

export const DependenciesNavigation = () => {
    const { state, actions } = useAppState();

    const { isActive, openStatus, shouldAnimateClosedComponent, recentOpened, dependencies } = state;
    const { activateNavigation, open, setCurrentEntityNameAndType, addRecentOpened, setAllDependencies } = actions;

    const queryKey = `dependencies-for-${getRequestMetadata()?.entityName}-${getRequestMetadata()?.entityVersion}`;
    const queryEnabled = openStatus === OpenStatusEnum.OPEN;

    const { isLoading, data, error } = useQuery({
        queryKey: [queryKey],
        queryFn: getDependencies,
        enabled: queryEnabled,
        refetchOnWindowFocus: false,
    });

    // // update dependencies navigation on hashchange
    // useEffect(() => {
    //     function handler() {
    //         const i = 0;
    //     }
    //
    //     window.addEventListener('hashchange', handler);
    //     return () => window.removeEventListener('hashchange', handler);
    // }, []);

    useEffect(() => {
        if (data) {
            setAllDependencies(data);
        }
    }, [data]);

    useEffect(() => {
        if (error) {
            open(OpenStatusEnum.INITIAL_HIDE);
            activateNavigation(false);
            alert('Dependencies Navigation Error: ' + (error as any).message);
        }
    }, [error]);

    useEffect(() => {
        const updateIsActiveForLocation = () => {
            const requestLocationKey = getRequestLocationKey();
            activateNavigation(!!requestLocationKey);
        };

        updateIsActiveForLocation();

        window.addEventListener('hashchange', updateIsActiveForLocation);
        return () => window.removeEventListener('hashchange', updateIsActiveForLocation);
        // eslint-disable-next-line
    }, [openStatus]);

    function getDependencies() {
        const metadata = getRequestMetadata();

        setCurrentEntityNameAndType({
            Name: metadata.entityName,
            EntityType: metadata.entityType as any,
            Version: (metadata as any).entityVersion || 0,
        });

        open(openStatus === OpenStatusEnum.MANUAL_HIDE ? OpenStatusEnum.INITIAL_HIDE : openStatus);

        return getData(metadata);
    }

    if (!isActive) {
        return <></>;
    }

    return (
        <>
            {openStatus !== OpenStatusEnum.INITIAL_HIDE ? (
                <OpenedMenu
                    isLoading={isLoading}
                    openStatus={openStatus}
                    recentOpened={recentOpened}
                    dependencies={dependencies}
                    handleClose={() => {
                        open(OpenStatusEnum.MANUAL_HIDE);
                    }}
                    handleTransition={addRecentOpened}
                />
            ) : (
                <></>
            )}

            {openStatus === OpenStatusEnum.INITIAL_HIDE || openStatus === OpenStatusEnum.MANUAL_HIDE ? (
                <ClosedMenu
                    shouldAnimate={shouldAnimateClosedComponent}
                    handleOpen={() => {
                        open(OpenStatusEnum.OPEN);
                    }}
                />
            ) : (
                <></>
            )}
        </>
    );
};
